
import React, { Component } from 'react';

import CheckBox from '../../../../components/ZUILib/CheckBox';
import TextInput from '../../../../components/ZUILib/TextInput';
import InputButton from '../../../../components/ZUILib/InputButton';
import commonUtil from '../../../../utils/commonUtil';
import serverClientUtil from '../../../../utils/serverClientUtil';

import errorLables from '../../../../utils/errors/LP_GR_error.json';

class SignIn extends Component {
  constructor() {
    super();
    this.clickHandlerForgotPassword = this.clickHandlerForgotPassword.bind(this);
    this.toggleRemeberMeMessage = this.toggleRemeberMeMessage.bind(this);
  }
  clickHandlerForgotPassword() {
    this.setState({ t: 't' });
    const _url = serverClientUtil.getLPFullURL() + '/users/forgotPassword?login=';
    window.open(_url);
  }
  loginForm = {
    login: '',
    password: '',
    autoLoginCheckbox: '',
  }

  validate = () => {
    const emailValidationRules = [
      { functionRef: commonUtil.isValueAvailable, funcData: [this.login.getValue()], errorMessage: commonUtil.getError(errorLables.createAccount, 'ca.login.email.required') },
      { functionRef: commonUtil.validateEmail, funcData: [this.login.getValue()], errorMessage: commonUtil.getError(errorLables.createAccount, 'ca.login.email.invalid') },
    ];

    const passwordValidationRiles = [
      { functionRef: commonUtil.isValueAvailable, funcData: [this.password.getValue()], errorMessage: commonUtil.getError(errorLables.createAccount, 'ca.login.password.required') },
      { functionRef: commonUtil.validatePassword, funcData: [this.password.getValue(), 8], errorMessage: commonUtil.getError(errorLables.createAccount, 'ca.login.password.invalid') },
    ];

    const isLoginValid = commonUtil.validateTextInput(emailValidationRules, this.login, null);
    const isPasswordValid = commonUtil.validateTextInput(passwordValidationRiles, this.password, null);

    if (isLoginValid && isPasswordValid) {
      this.loginForm.login = this.login.getValue();
      this.loginForm.password = this.password.getValue();
      this.loginForm.autoLoginCheckbox = this.userAutoLogingChk.isChecked() ? 'true' : 'false';
    }

    const { login, password } = this.loginForm;
    if (login && password) {
      return true;
    }

    // eslint-disable-next-line no-undef
    dataLayer.push({
      event: 'Login',
      Login: 'No Logueado',
    });
    return false;
  }
  toggleRemeberMeMessage = () => {
    const autologinTooltip = document.querySelector('#' + this.autoLoginTooltipsignInWeb.id);
    if (autologinTooltip.style.display === 'none') {
      autologinTooltip.style.display = 'block';
    } else {
      autologinTooltip.style.display = 'none';
    }
  }
  handleUserLogin = () => {
    if (this.validate()) {
      const { _handleUserLogin } = this.props; // eslint-disable-line no-shadow
      _handleUserLogin(this.loginForm).then((resp) => {
        if (resp.status.errorCode !== undefined) {
          // eslint-disable-next-line no-undef
          dataLayer.push({
            event: 'Login',
            Login: 'No Logueado',
          });
        } else {
          // eslint-disable-next-line no-undef
          dataLayer.push({
            event: 'Login',
            Login: 'Logueado',
          });
        }
      });
    }
  }
  render() {
    const { lables } = this.props;
    const SignInButton = {
      type: 'button',
      value: commonUtil.getLabel(lables.createLogin, 'login.button.label'),
      autoFocus: false,
      style: 'btnPrimary size-Full',
      onClickHandler: this.handleUserLogin,
    };
    const rememberMeCheckBoxConfig = {
      displayName: commonUtil.getLabel(lables.createLogin, 'login.keep.me.login'),
      id: 'signinchk',
      name: '',
      value: '',
      disabled: '',
    };
    return (
      <div className="col-xs-12 col-sm-6 col-md-4 col-md-offset-1" id="sectionSesion">
        <h5 className="fontBold" id="sesionText">{commonUtil.getLabel(lables.createLogin, 'login.to.my.account')}</h5>
        <form id="startSesion">
          <div className="formBlock">
            <TextInput
              className="inputMaterial"
              labelClassName="placeHolderMaterial"
              htmlId="usuario"
              label={commonUtil.getLabel(lables.createLogin, 'login.user.name')}
              name="User"
              maxlength="100"
              required="true"
              ref={login => this.login = login}
            />
          </div>
          <div className="formBlock">
            <TextInput
              className="inputMaterial"
              labelClassName="placeHolderMaterial"
              htmlId="loginContraseña"
              label={commonUtil.getLabel(lables.createLogin, 'login.user.password')}
              name="password"
              type="password"
              required="true"
              ref={password => this.password = password}
            />
          </div>
          <InputButton buttonAttr={SignInButton} />
          {/* eslint-disable */}
          <div className="row">
            <div className="col-xs-12 pl-0">
              <CheckBox displayName={rememberMeCheckBoxConfig.displayName} id={rememberMeCheckBoxConfig.id} ref={(e) => { this.userAutoLogingChk = e; }}>
                <a className="details" onClick={this.toggleRemeberMeMessage}>{commonUtil.getLabel(lables.createLogin, 'login.detalla.link')}<i className="icon-caret_down" /></a>
                <div className="homeSessionContainerCreateAccount" style={{ 'display': 'none' }} id="signInWebToolTip" ref={(e) => { this.autoLoginTooltipsignInWeb = e; }} >
                  <div className="rememberMeContent">
                    <p>{commonUtil.getLabel(lables.createLogin, 'createLogin.rememberme.header.content')} <i className="icon-tache closeContainer" onClick={this.toggleRemeberMeMessage} /></p>
                    <hr />
                    <p>{commonUtil.getLabel(lables.createLogin, 'createLogin.rememberme.content1')}</p>
                    <p>{commonUtil.getLabel(lables.createLogin, 'createLogin.rememberme.content2')}</p>
                  </div>
                </div>
              </CheckBox>
            </div>
          </div>
          <a className="forgotPassword" onClick={this.clickHandlerForgotPassword} >{commonUtil.getLabel(lables.createLogin, 'forgot.password.link')}</a>
        </form>
      </div>
    );
  }
}
export default SignIn;
